import { useTopBannerList } from './hooks';
import { convertToPresentationProps } from './logics';
import { TopBannerListPresentation } from './presentations';
import { TopBannerListEmptyPresentation } from './presentations/empty';

/**
 * トップバナー一覧のコンテナコンポーネント
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const TopBannerList: React.FC = () => {
  const {
    state: { data },
    actions: { handleSelectedDropdownMenu, handleReOrder },
  } = useTopBannerList();

  const { topBanners, createLink } = convertToPresentationProps({ data });

  if (topBanners.length === 0) {
    return <TopBannerListEmptyPresentation createLink={createLink} />;
  }

  return (
    <TopBannerListPresentation
      topBanners={topBanners}
      createLink={createLink}
      onSelectedDropdownMenu={handleSelectedDropdownMenu}
      onReOrder={handleReOrder}
    />
  );
};
